import api from './api'

let basePath = 'academy/api/'

const commentDataProvider = {
  postComment(params = {}, path) {
    return api.post(basePath + path, {
      ...params,
    })
  },
  getComment(id, path) {
    return api.get(basePath + path + id)
  },
  CountCommentStatus(id, path) {
    return api.get(basePath + path + id)
  },
  putCommentStatus(params = {}, path) {
    return api.put(basePath + path, {
      ...params,
    })
  },
  postCommentReply(params = {}, path) {
    return api.post(basePath + path, {
      ...params,
    })
  },
}

export default commentDataProvider
